import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "../helper";
import ChallanBaseButton from "../Buttons/ChallanBaseButton";

export default function Confirm({ title, content, open, onClose, onConfirm }) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ mx: 1.5, mb: 1.5 }}>
          <ChallanBaseButton
            onClick={onClose}
            text={"Cancel"}
            type={"cancel"}
            width={100}
          />
          <ChallanBaseButton
            onClick={onConfirm}
            text={"Confirm"}
            type={"ok"}
            width={100}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
